<template>
  <div class="articleEditor container">
    <div class="ab">
      <div class="title1">
        <article-title/>
      </div>
      <div class="title2">
        <home-title :user="user" :active-tab="activeTab" @changeTab="changeTab"/>
      </div>
      <div class="homeData container">
        <left-tab :active-tab="activeTab" role="self" @changeTab="changeTab"/>
        <div class="rightData">
          <user-article v-if="activeTab === 'article'"/>
          <user-info @updateUser="updateUser" v-if="activeTab === 'info'"/>
          <user-msg v-if="activeTab === 'msg'"/>
          <user-collect v-if="activeTab === 'collect'"/>
          <user-focus @updateUser="updateUser" v-if="activeTab === 'focus'"/>
          <user-follower @updateUser="updateUser" v-if="activeTab === 'follow'"/>
        </div>
      </div>
    </div>
    <loading text='加载中...' duration='2s' v-show="isLoad"></loading>
  </div>
</template>
<script>
import * as types from '../../common/js/types'
import articleTitle from '../common/articleTitle.vue'
import homeTitle from './base/homeTitle.vue'
import leftTab from './base/leftTab'
import userInfo from './userInfo'
import userArticle from './userArticle'
import userMsg from './userMsg'
import userCollect from './userCollect'
import userFocus from './userFocus'
import userFollower from './userFollower'
import loading from '../common/loading.vue'
export default {
  name: 'userHome',
  data () {
    return {
      msg: '个人中心',
      activeTab: 'article',
      user: {
        'userId': '402888c563f7211f0163f721b2d10000',
        'userPhone': '15902059569',
        'passWord': '0A1BAB267B4603F4',
        'accesstoken': '5fda383f-44ca-4e38-9068-69e5b3a8988f',
        'userName': '用户9569',
        'sex': null,
        'birthday': null,
        'address': null,
        'signName': null,
        'articleNum': 18,
        'focusNum': 2,
        'followerNum': 1,
        'score': 124,
        'comeWay': 'WX',
        'headImg': null,
        'createTime': 1528859570000,
        'lastLoginTime': 1532333754000
      },
      isLoad: true
    }
  },
  computed: {
  },
  created: function () {
    if (localStorage.getItem('userHome_activeTab')) {
      this.activeTab = localStorage.getItem('userHome_activeTab')
    }
    if (this.$root.getUserId()) {
      this.updateUser()
    }
    this.isLoad = false
  },
  mounted: function (s) {
  },
  methods: {
    updateUser: function () {
      if (this.$root.getUserId()) {
        this.isLoad = true
        let that = this
        that.axios.post('userInfo', {
          userId: this.$root.getUserId()
        }, {
          emulateJSON: true// 需要转json
        }).then(function (response) {
          that.isLoad = false
          if (response.data.status === 0) {
            var res = response.data.value
            that.user = res
            that.$store.commit(types.LOGIN, res)
          } else {
            that.$store.commit('setToastMsg', response.data.msg)
          }
        }).catch(function (response) {
          that.isLoad = false
          that.$store.commit('setToastMsg', '网络错误')
        })
      }
    },
    changeTab: function (tab) {
      this.activeTab = tab
      localStorage.setItem('userHome_activeTab', this.activeTab)
    }
  },
  filters: {},
  components: {
    articleTitle,
    homeTitle,
    leftTab,
    userInfo,
    userArticle,
    userMsg,
    userCollect,
    userFocus,
    userFollower,
    loading
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.articleEditor {
  padding-top: 52px;
}
.ab {
  width: 100%;
  min-width: 1200px;
  background-color: #F0F0F0;
  padding-bottom: 20px;
}
.title1 {
  margin: 0 auto;
  width: 1200px;
  margin-top: 10px;
  text-align: left;
  height: auto;
  font-size: 16px;
  color: #333333;
}
.title2 {
  width: 100%;
  min-width: 1200px;
  margin: 0 auto;
}
.homeData {
  width: 1200px;
  margin: 0 auto;
  margin-top: 10px;
}
.rightData {
  float: left;
  width: 950px;
  margin-left: 20px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/user/userHome.vue